var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-discount-main-container"},[_c('p',[_vm._v("Usted es un cliente especial. Tiene un descuento general del "+_vm._s(_vm.discount)+"%")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.closeMessage}},[_vm._v("×")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90161f9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/app-customer-discount.vue
// module id = 505
// module chunks = 34